// Will handle:
// fetch logic from backend
// normalize fetched data
// cache the fetched data and update accordingly
// manage all the loasing states

import { useEffect, useState } from "react";

// import utils
import { normalizeProductData } from "../utils/normalizeProductData";
import { fetchProductById } from "@/services/catalogueApi";
import { useBusiness } from "@hooks/useBusiness";

const useProductFormLoader = (productId) => {
  const { businessId } = useBusiness();
  const [normalizedData, setNormalizedData] = useState(null);
  const [isLoading, setIsLoading] = useState(!productId);
  const [error, setError] = useState(null);

//   fetch the data from backend
  useEffect(() => {
     // Skip fetch if no ID (create mode)
    if (!productId || !businessId) {
      setIsLoading(false);
      return;
    }

    const fetchAndNormalize = async () => {
      try {
        const product = await fetchProductById(businessId, productId);

        // if no product was found
        if (!product) {
          throw new Error("Product not found");
        }

        // normalize fetched data
        const normalized = normalizeProductData(product);
        setNormalizedData(normalized);
        
      } catch (err) {

        setError(err.message || "Failed to load product data");

      } finally {

        setIsLoading(false);

      }
    };

    fetchAndNormalize();
  }, [productId, businessId]);

  return { data: normalizedData, isLoading, error };

};

export default useProductFormLoader;